import { useEffect, useState } from "react";
import { useIntl } from "@/infra/locale";
import { careEnvironment } from "@akina/config";
import { isApp } from "@akina/utils";
import { invoke } from "@tauri-apps/api/core";
import { confirm } from "@tauri-apps/plugin-dialog";
import { platform } from "@tauri-apps/plugin-os";
import { exit } from "@tauri-apps/plugin-process";

export function useMoveAppToFolderOnMacOS() {
  const { formatMessage } = useIntl();

  const [isIntlReady, setIsIntlReady] = useState(false);

  useEffect(() => {
    try {
      formatMessage({ id: "dashboard.appExecPathDialog.description" });
      formatMessage({ id: "dashboard.appExecPathDialog.title" });
      formatMessage({ id: "dashboard.appExecPathDialog.quitButton" });
      formatMessage({ id: "dashboard.appExecPathDialog.ignoreButton" });
      queueMicrotask(() => setIsIntlReady(true));
    } catch (error) {
      console.error("Calling FormatMessage Error, might be not ready yet:", error);
      setTimeout(() => setIsIntlReady(false), 300);
    }
  }, [formatMessage]);

  useEffect(() => {
    if (!isApp || !isIntlReady) return;

    async function checkAppPath() {
      const currentPlatform = platform();
      if (String(currentPlatform) !== "macos" || careEnvironment.environment == "dev") return;

      try {
        const execPath: string = await invoke("get_executable_path");

        if (!execPath.startsWith("/Applications")) {
          const quitApp = await confirm(formatMessage({ id: "dashboard.appExecPathDialog.description" }), {
            title: formatMessage({ id: "dashboard.appExecPathDialog.title" }),
            okLabel: formatMessage({ id: "dashboard.appExecPathDialog.quitButton" }),
            cancelLabel: formatMessage({ id: "dashboard.appExecPathDialog.ignoreButton" }),
          });

          if (quitApp) {
            const execPath: string = await invoke("get_executable_path");
            await invoke("show_in_finder", { path: execPath });
            await exit(0);
          }
        }
      } catch (error) {
        console.error("Error checking app location:", error);
      }
    }

    checkAppPath();
  }, [formatMessage, isIntlReady]);
}
